
import React, { useState } from "react";
import "./AssociateCards.css";

import cardFront from "../../images/cartao_associado_frente.svg";
import cardBack from "../../images/cartao_associado_verso.svg";
import toggle0 from "../../images/associate-cards__toggle_0.svg";
import toggle1 from "../../images/associate-cards__toggle_1.svg";


export default function AssociateCards({
    userName,
    membershipNumber
}) {
    const [showBack, setShowBack] = useState(false);
    const formatCardNumber = (cardNumber = "") => {
        if (!cardNumber) return 'E 0000.000-0';

        // Remove any non-alphanumeric characters
        const cleanNumber = cardNumber.replace(/[^A-Za-z0-9]/g, '');

        // Format: E 0000.000-0
        return `${cleanNumber[0]} ${cleanNumber.slice(1, 5)}.${cleanNumber.slice(5, 8)}-${cleanNumber.slice(8)}`;
    };


    return (
        <section className="associate-cards">
            <div className="associate-cards__content">
                <div
                    className={`associate-cards__front-wrapper ${showBack ? "associate-cards__face--hidden" : ""
                        }`}
                >
                    <img
                        className="associate-cards__image"
                        src={cardFront}
                        alt="Frente do cartão de associado"
                    />

                    <div className="associate-cards__details">
                        <span
                            className="associate-cards__name"
                            title={userName || "NOME DO ASSOCIADO"}
                        >
                            {userName || "NOME DO ASSOCIADO"}
                        </span>

                        <span className="associate-cards__number">
                            {formatCardNumber(membershipNumber)
                            }
                        </span>
                    </div>
                </div>

                <img
                    className={`associate-cards__image associate-cards__back ${showBack ? "associate-cards__face--visible" : ""
                        }`}
                    src={cardBack}
                    alt="Verso do cartão de associado"
                />
            </div>

            <button
                type="button"
                className="associate-cards__toggle"
                onClick={() => setShowBack((current) => !current)}
            >
                {showBack
                    ? (<img src={toggle1} alt="verso" />)
                    : (<img src={toggle0} alt="frente" />)}
            </button>
        </section>
    );
}
